// 설정 창 "앱 설치 · 업데이트" 묶음. 설치 안내는 처음 열었을 때 한 번 강조하고(그 뒤로는 조용한 한 줄), 새 버전이 기다리면 "지금 적용" 단추를 둔다.
// 서비스 워커를 쓸 수 없는 환경(인앱 브라우저·개발 서버·http)에서는 아무것도 그리지 않는다. 설정 창 안에만 그리므로 플레이 화면을 가리지 않는다.
import { C, FONT } from '../ui/dom';
import { formatBytes } from './patch';
import { applyUpdateNow, loadPwaPrefs, onPwaChange, promptInstall, pwaState, savePwaPrefs } from './register';

function div(parent: HTMLElement, css: string, text?: string): HTMLDivElement {
  const d = document.createElement('div');
  d.style.cssText = css;
  if (text !== undefined) d.textContent = text;
  parent.appendChild(d);
  return d;
}

function small(parent: HTMLElement, label: string, testId: string, onClick: () => void): HTMLButtonElement {
  const b = document.createElement('button');
  b.type = 'button';
  b.textContent = label;
  b.dataset.testid = testId;
  b.style.cssText = 'pointer-events:auto;cursor:pointer;min-height:44px;font:800 15px ' + FONT + ';padding:8px 14px;border-radius:10px;box-shadow:0 3px 0 rgba(0,0,0,.4);white-space:nowrap;background:linear-gradient(#26335a,#1A2238);color:' + C.gold + ';border:2px solid ' + C.gold + ';';
  b.addEventListener('click', onClick);
  parent.appendChild(b);
  return b;
}

/** 설치 안내 문구(순수에 가깝게 분리: 시험에서 환경별 문구를 확인한다) */
export function installHint(s: { installed: boolean; canInstall: boolean; ios: boolean }): { kind: 'installed' | 'prompt' | 'ios' | 'menu'; text: string } {
  if (s.installed) return { kind: 'installed', text: '홈 화면 앱으로 실행 중이에요. 전체 화면으로 즐기세요.' };
  if (s.canInstall) return { kind: 'prompt', text: '홈 화면에 앱으로 설치하면 전체 화면으로 열리고, 접속할 때마다 다시 받는 양이 줄어요.' };
  if (s.ios) return { kind: 'ios', text: 'Safari 아래쪽 공유 버튼(□↑)을 누르고 ‘홈 화면에 추가’를 고르면 앱처럼 전체 화면으로 열려요.' };
  return { kind: 'menu', text: '브라우저 메뉴(⋮)에서 ‘앱 설치’ 또는 ‘홈 화면에 추가’를 고르면 앱처럼 열려요.' };
}

export interface PwaSection { refresh(): void }

export function mountPwaSection(parent: HTMLElement): PwaSection {
  const box = div(parent, 'display:none;flex-direction:column;gap:8px;padding:12px 14px;border:1px solid rgba(242,193,78,.45);border-radius:12px;background:rgba(10,16,34,.55);');
  box.dataset.testid = 'pwa-section';
  div(box, 'font:800 18px ' + FONT + ';color:#fff;', '앱 설치 · 업데이트');
  const hint = div(box, 'font:500 12px ' + FONT + ';color:#9fb0d8;line-height:1.45;');
  hint.dataset.testid = 'pwa-hint';
  const actions = div(box, 'display:flex;flex-wrap:wrap;gap:8px;align-items:center;');
  const upd = div(box, 'font:700 13px ' + FONT + ';color:' + C.gold + ';line-height:1.45;');
  upd.dataset.testid = 'pwa-update-line';
  let installBtn: HTMLButtonElement | null = null;
  let applyBtn: HTMLButtonElement | null = null;

  const refresh = (): void => {
    const s = pwaState();
    // 쓸 수 없는 환경이거나 앱 안 브라우저면 이 묶음을 숨긴다
    if (!s.supported || s.inApp) { box.style.display = 'none'; return; }
    box.style.display = 'flex';
    const h = installHint(s);
    hint.textContent = h.text;
    actions.textContent = '';
    installBtn = null; applyBtn = null;
    if (h.kind === 'prompt') installBtn = small(actions, '앱으로 설치', 'pwa-install', () => { void promptInstall().then(() => refresh()); });
    if (s.updateReady) {
      upd.textContent = '새 업데이트' + (s.updateBytes > 0 ? ' ' + formatBytes(s.updateBytes) : '') + '가 준비됐어요. 다음 접속 때 저절로 적용돼요.';
      applyBtn = small(actions, '지금 적용', 'pwa-apply', () => { applyUpdateNow(); });
    } else upd.textContent = '';
    // 설치 안내는 처음 한 번만 강조한다
    const p = loadPwaPrefs();
    box.style.borderColor = !p.hintSeen && !s.installed ? C.gold : 'rgba(242,193,78,.45)';
    if (!p.hintSeen && !s.installed) { p.hintSeen = true; savePwaPrefs(p); }
    void installBtn; void applyBtn;
  };
  onPwaChange(refresh);
  refresh();
  return { refresh };
}
